import { DEFAULT_TOAST_LIFE } from "../../../../common/EzToast";
import { UsersService } from "../../../../services";
import { goBack } from "../../../../utils/gotoback";
import {
  TOAST,
  FETCH_USERS_LIST,
  FETCH_USERINFO_INIT,
  FETCH_USERS_DETAIL,
  UPDATE_USER,
  USER_ROLESDD,
  CREATE_USER,
  INIT_CREATE_USER_SCREEN,
  FETCH_USER_CREATE_MENU_LIST,
  FETCH_LOCATIONS_DD,
  USERS_SAVE_TABLE_STATE,
} from "../../../types/Systems/Users.type";

export const initializeUserInfoScreen = () => ({ type: FETCH_USERINFO_INIT });

export const userFetchStart = (payload) => ({
  type: FETCH_USERS_LIST.START,
  payload,
});

export const userFetchSuccess = (payload) => ({
  type: FETCH_USERS_LIST.SUCCESS,
  payload,
});

export const userFetchError = (payload) => ({
  type: FETCH_USERS_LIST.ERROR,
  payload,
});

export const fetchUser = (payload) => {
  return (dispatch) => {
    dispatch(userFetchStart(payload));
    UsersService.fetchUser(payload).then((userData) => {
      if (!userData.isError) {
        dispatch(userFetchSuccess(userData));
      } else {
        dispatch(userFetchError(userData));
      }
    });
  };
};

export const resetToast = (payload) => ({
  type: TOAST.RESET,
  payload,
});

export const UsersDetailFetchStart = (payload) => ({
  type: FETCH_USERS_DETAIL.START,
  payload,
});

export const UsersDetailFetchSuccess = (payload) => ({
  type: FETCH_USERS_DETAIL.SUCCESS,
  payload,
});

export const UsersDetailFetchError = (payload) => ({
  type: FETCH_USERS_DETAIL.ERROR,
  payload,
});

export const fetchUsersById = (payload) => {
  return (dispatch) => {
    dispatch(UsersDetailFetchStart(payload));

    UsersService.fetchUsersById(payload).then((data) => {
      if (!data.isError) {
        dispatch(UsersDetailFetchSuccess(data));
      } else {
        dispatch(UsersDetailFetchError(data));
      }
    });
  };
};

//Update user
export const updateUserStart = () => ({
  type: UPDATE_USER.START,
});

export const updateUserSuccess = (payload) => ({
  type: UPDATE_USER.SUCCESS,
  payload,
});

export const updateUserError = (payload) => ({
  type: UPDATE_USER.ERROR,
  payload,
});

export const updateUser = (payload) => {
  return (dispatch) => {
    dispatch(updateUserStart());
    UsersService.updateUser(payload).then((data) => {
      if (!data.isError) {
        dispatch(updateUserSuccess());
        goBack();
      } else {
        dispatch(updateUserError(data));
      }
      setTimeout(() => {
        dispatch(resetToast());
      }, DEFAULT_TOAST_LIFE + 1000);
    });
  };
};

export const createUserScreenInitStart = (payload) => ({
  type: INIT_CREATE_USER_SCREEN,
  payload,
});

export const initCreateUserScreen = (payload) => {
  return (dispatch) => {
    dispatch(createUserScreenInitStart(payload));
  };
};

export const createUserStart = () => ({
  type: CREATE_USER.START,
});

export const createUserSuccess = (payload) => ({
  type: CREATE_USER.SUCCESS,
  payload,
});

export const createUserError = (payload) => ({
  type: CREATE_USER.ERROR,
  payload,
});

export const createUser = (payload) => {
  return (dispatch) => {
    dispatch(createUserStart());
    UsersService.createUser(payload).then((data) => {
      if (!data.isError) {
        dispatch(createUserSuccess(data));
        goBack();
      } else {
        dispatch(createUserError(data));
      }

      setTimeout(() => {
        dispatch(resetToast());
      }, DEFAULT_TOAST_LIFE + 1000);
    });
  };
};

// DD
export const userRolesDDFetchStart = (payload) => ({
  type: USER_ROLESDD.START,
  payload,
});

export const userRolesDDFetchSuccess = (payload) => ({
  type: USER_ROLESDD.SUCCESS,
  payload,
});

export const userRolesDDFetchError = (payload) => ({
  type: USER_ROLESDD.ERROR,
  payload,
});

export const fetchUserRolesDD = (payload) => {
  return (dispatch) => {
    dispatch(userRolesDDFetchStart(payload));
    UsersService.fetchUserRolesDropdown(payload).then((data) => {
      if (!data.isError) {
        dispatch(userRolesDDFetchSuccess(data));
      } else {
        dispatch(userRolesDDFetchError(data));
      }
    });
  };
};

export const fetchUserCreateMenuListStart = (payload) => ({
  type: FETCH_USER_CREATE_MENU_LIST.START,
  payload,
});

export const fetchUserCreateMenuListSuccess = (payload) => ({
  type: FETCH_USER_CREATE_MENU_LIST.SUCCESS,
  payload,
});

export const fetchUserCreateMenuListError = (payload) => ({
  type: FETCH_USER_CREATE_MENU_LIST.ERROR,
  payload,
});

export const fetchUserCreateMenuList = (payload) => {
  return (dispatch) => {
    dispatch(fetchUserCreateMenuListStart(payload));

    UsersService.fetchUserCreateMenuList(payload).then((data) => {
      if (!data.isError) {
        dispatch(fetchUserCreateMenuListSuccess(data));
      } else {
        dispatch(fetchUserCreateMenuListError(data));
      }
    });
  };
};

const fetchLocationsStart = () => ({ type: FETCH_LOCATIONS_DD.START });

const fetchLocationsSuccess = (payload) => ({
  type: FETCH_LOCATIONS_DD.SUCCESS,
  payload,
});

const fetchLocationsError = (payload) => ({
  type: FETCH_LOCATIONS_DD.ERROR,
  payload,
});

export const fetchLocationsDD = () => {
  return (dispatch) => {
    dispatch(fetchLocationsStart());
    UsersService.fetchAllLocations().then((res) => {
      if (!res.isError) {
        dispatch(fetchLocationsSuccess(res));
      } else {
        dispatch(fetchLocationsError(res));
      }
    });
  };
};

/*----------------TABLE STATE PERSISTENCE----------------------------*/
export const saveUsersTableState = (payload) => ({
  type: USERS_SAVE_TABLE_STATE,
  payload,
});
/*----------------END TABLE STATE PERSISTENCE----------------------------*/
